<template>
  <div class="component">

    <br />

    <div id="presentation">
      <p>
        Boråspartiers Facebookflöden låter dig jämföra Borås lokala politiska partier sida vid sida.
      </p>
      <p>
        Hur kommunicerar de olika partierna på sociala medier? Vilka tycks vara deras hjärtefrågor? Håller du med om vad de skriver?
      </p>
    </div>

    <div id="parties">
      <strong>Facebookflöden:</strong>
      <div v-for="party in feeds.parties" class="party">
        <party-check :party="party"></party-check>
      </div>
    </div>

    <br /><br />

    <div>

      <div id="feedsContainer">

        <!--div class="scrollTriangle scrollLeft" @click="scrollToPrevious()" >
          <img src="/static/graphics/left.png"/>
        </div-->

        <div id="feeds">
          <template v-for="party in feeds.parties" v-show="party.active" class="feedContainer">

            <!--div class="partyName" v-show="party.active">
              <span>{{party.name}}</span>
            </div-->

            <div v-for="feed in party.feeds" v-show="party.active && feed.active">

              <feed-facebook v-if="feed.platform == 'facebook'" :id="feed.id" :alt="feed.name" class="feed"></feed-facebook>

              <feed-twitter v-if="feed.platform == 'twitter'" :id="feed.id" :alt="feed.name" class="feed"></feed-twitter>

            </div>

          </template>

        </div>

        <!--div class="scrollTriangle scrollRight" @click="scrollToNext()">
          <img src="/static/graphics/right.png" />
        </div-->

      </div>

      <div class="scrolls">

        <div class="scroll" @click="scrollToPrevious()" >
          <img src="/static/graphics/left.png"/>
        </div>

        <div class="scroll" @click="scrollToNext()">
          <img src="/static/graphics/right.png" />
        </div>

      </div>

    </div>



  </div>
</template>

<script>

import jsonFeeds from '@/assets/feeds.json';
import PartyCheck from '@/components/PartyCheck.vue'
import FeedFacebook from '@/components/FeedFacebook.vue'
import FeedTwitter from '@/components/FeedTwitter.vue'

export default {
  name: 'Feeds',
  components: {
    PartyCheck,
    FeedFacebook,
    FeedTwitter
  },
  data () {
    return {
      feeds: jsonFeeds,
      feedsRender: [],
      c: "blue"
    }
  },
  props: {
    href: "",
    alt: ""
  },
  methods: {
    reload: function () {
      FB.XFBML.parse(this.$el);
    },
    scroll: function (dir) {
      var pixels = dir * 500;
      document.getElementById("feeds").scrollBy({left: pixels, behavior: 'smooth' });
    },
    scrollToElement: function (event) {
      document.getElementById("feeds").scroll({left: event.srcElement.offsetLeft-10, behavior: 'smooth' });
    },
    scrollToNext: function () {
      var feedsAll = document.getElementsByClassName("feed");
      var scroll = document.getElementById("feeds").scrollLeft;

      for(var i = 0; i <= feedsAll.length; i++){
        var feed = feedsAll[i];
        if(feed.offsetParent){
          var offset = feed.offsetLeft - scroll;
          var margin = 0;
          if(offset > margin){
              document.getElementById("feeds").scroll({left: feed.offsetLeft-margin, behavior: 'smooth' });
              break;
          }
        }
      }
    },
    scrollToPrevious: function () {
      var feedsAll = document.getElementsByClassName("feed");
      var scroll = document.getElementById("feeds").scrollLeft;

      for(var i = feedsAll.length - 1; i >= 0; i--){
        var feed = feedsAll[i];
        if(feed.offsetParent){
          var offset = feed.offsetLeft - scroll;
          var margin = 0;
          if(offset < -margin){
              document.getElementById("feeds").scroll({left: feed.offsetLeft-margin, behavior: 'smooth' });
              break;
          }
        }
      }
    }
  },
  computed: {
  },
  created: function (){

    //Load Facebook API
    /*(function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/sv_SE/sdk.js#xfbml=1&version=v2.12&appId=1196347747065674&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));*/
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#component{
  text-align: center;
}

#presentation{
  padding: 20px;
}

#parties{
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  min-width: 50%;
  margin: 0 auto;
  padding: 0px 20px 0px 20px;
  background: rgb(65,103,178);
  color: white;
}

#parties .party{
  margin: 10px;
}

#feedsContainer{
  background: rgb(240,240,240);
  display: flex;
  align-items: stretch;
  justify-content: center;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
}



#feeds{
  display: flex;
  justify-content: flex-start;
  height: 500px;
  max-width: 100%;
  overflow-x: scroll;
  padding: 10px 0px 20px 0px;
}

.feedContainer{
  flex: 0 0 100%;
  padding: 5px;
}

.feed{
  background: white;
  height: 100%;

  box-shadow: 4px 4px 4px gray;
  border: 0px solid gray;
  margin: 4px;
}

@media screen and (max-width: 600px) {

  .feed{
    margin: 0px;
  }

}

.scrolls{
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: sticky;
  bottom: 0px;
  width: 100%;
}

.scroll {
  margin: 20px;
  padding: 20px;
  cursor: pointer;
  background: rgba(200,200,200,0.7);
  transition: 0.25s all;
  z-index: 10;
}

.scroll:hover{
  background: rgba(200,200,200,0.9);
}

.scroll img{
  width: 20px;
  margin: 0px;
}

.partyName{
  padding: 10px 10px 10px 20px;
  font-size: 12pt;
  margin-left: 10px;
}

.partyName span{
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: right;
  color: black;
  background: rgb(220,220,220);
  padding: 5px;
}

.scrollTriangle{
  cursor: pointer;
  display: flex;
  align-items: center;
  align-content: center;
  /*background: rgb(65,103,178);*/
  background: #ddd;
  color: white;
  transition: 0.1s all;
  width: 0px;
  overflow: hidden;
  padding: 0px;
}

#feedsContainer:hover .scrollTriangle{
  width: 50px;
}

.scrollTriangle:hover{
  width: 100px !important;
}

.scrollTriangle img{
  width: 20px;
  align-self: center;
  margin: 0 auto;
}

.scrollLeft{
  border-right: 1px solid lightgray;
  justify-content: flex-start;
}

.scrollRight{
  border-left: 1px solid lightgray;
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/components/Feeds.vue